import { StringUtil } from '@root/shared'

import type { UserProfileHoldingsWallet } from '../model/user-profile-holdings-wallet'
import type { Column } from '@root/shared/ui-kit'

export type HoldingsTableColumn = 'name' | 'address' | 'balance' | 'assets'

export const holdingsTableColumns: Array<
  Column<UserProfileHoldingsWallet, HoldingsTableColumn, undefined>
> = [
  {
    id: 'address',
    header: ({ t }) => t('common.address'),
    render: () => <></>,
    minWidth: 140,
  },
  {
    id: 'balance',
    header: ({ t }) => t('common.balance'),
    render: () => <></>,
    minWidth: 140,
    getValue: (value) => value.totalBalanceUsd.toNumber(),
    sortable: true,
  },
  {
    id: 'assets',
    header: ({ t }) => StringUtil.capitalize(t('asset_other')),
    render: () => <></>,
    minWidth: 140,
    getValue: (value) => value.assets.length,
    sortable: true,
  },
]
